(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yg-buy-it-now')) {
    class YGBuyItNow extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        const trigger = this.querySelector('.yg-buy-button');
        if (!trigger) return;
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          if (this.classList.contains('disabled')) return;
          const real =
            this.querySelector('.shopify-payment-button .shopify-payment-button__more-options') ||
            this.querySelector('.shopify-payment-button .shopify-payment-button__button') ||
            this.querySelector('shop-pay-wallet-button button');
          if (real) real.click();
        });
      }
    }
    customElements.define('yg-buy-it-now', YGBuyItNow);
  }

  if (!window.__ygBundleSubmitHooked) {
    window.__ygBundleSubmitHooked = true;

    const collectBundleItems = (form) => {
      const scope = form.closest('.shopify-section') || document;
      const items = [];
      scope.querySelectorAll('.yg-buy-with__item').forEach((item) => {
        const cb = item.querySelector('.yg-buy-with__checkbox-input');
        if (!cb || !cb.checked) return;
        const id = parseInt(item.getAttribute('data-product-id'), 10);
        const qty = parseInt(item.getAttribute('data-quantity-number') || '1', 10);
        if (id && qty > 0) items.push({ id, quantity: qty });
      });
      return items;
    };

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (form.getAttribute('is') !== 'product-form') return;

        const bundles = collectBundleItems(form);
        if (!bundles.length) return;

        const idInput = form.querySelector('input[name="id"]');
        const quantityInput = Array.from(form.elements).find((el) => el.name === 'quantity');
        if (!idInput || !idInput.value) return;

        const mainId = parseInt(idInput.value, 10);
        const mainQty = parseInt((quantityInput && quantityInput.value) || '1', 10) || 1;

        const allItems = [{ id: mainId, quantity: mainQty }, ...bundles];

        const tempInputs = [];
        const addHidden = (name, value) => {
          const inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = name;
          inp.value = String(value);
          inp.setAttribute('data-yg-bundle-temp', '');
          form.appendChild(inp);
          tempInputs.push(inp);
        };

        allItems.forEach((it, idx) => {
          addHidden(`items[${idx}][id]`, it.id);
          addHidden(`items[${idx}][quantity]`, it.quantity);
        });

        form.querySelectorAll('input[name^="properties["]').forEach((el) => {
          const match = el.name.match(/^properties\[([^\]]+)\]$/);
          if (!match) return;
          if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
          if (!el.value) return;
          addHidden(`items[0][properties][${match[1]}]`, el.value);
          el.disabled = true;
          tempInputs.push({ _restoreEl: el });
        });

        const previousIdDisabled = idInput.disabled;
        idInput.disabled = true;
        let previousQtyDisabled = null;
        if (quantityInput) {
          previousQtyDisabled = quantityInput.disabled;
          quantityInput.disabled = true;
        }

        const restore = () => {
          tempInputs.forEach((entry) => {
            if (entry instanceof HTMLElement) {
              entry.remove();
            } else if (entry && entry._restoreEl) {
              entry._restoreEl.disabled = false;
            }
          });
          idInput.disabled = previousIdDisabled;
          if (quantityInput) quantityInput.disabled = previousQtyDisabled;
          form.removeEventListener('variant:add', restore);
          form.removeEventListener('cart:error', restore);
        };

        form.addEventListener('variant:add', restore, { once: true });
        form.addEventListener('cart:error', restore, { once: true });
        setTimeout(restore, 15000);
      },
      { capture: true }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    const gallery = document.querySelector('product-gallery');
    if (!gallery) return;

    const thumbControls = gallery.querySelector('[data-yg-thumb-controls]');
    if (!thumbControls) return;

    const imageCarousel = gallery.querySelector('[data-yg-image-carousel]');
    const videoCarousel = gallery.querySelector('[data-yg-video-carousel]');
    const thumbItems = Array.from(gallery.querySelectorAll('.yg-thumb-item'));
    const prevBtn = gallery.querySelector('[data-yg-thumb-prev]');
    const nextBtn = gallery.querySelector('[data-yg-thumb-next]');
    const overflowEnd = gallery.querySelector('[data-yg-thumb-overflow]');
    const overflowEndCount = gallery.querySelector('[data-yg-thumb-overflow-count]');
    const overflowStart = gallery.querySelector('[data-yg-thumb-overflow-start]');
    const overflowStartCount = gallery.querySelector('[data-yg-thumb-overflow-start-count]');
    const counterCurrent = gallery.querySelector('[data-yg-counter-current]');
    const counterTotal = gallery.querySelector('[data-yg-counter-total]');
    const videoBtn = gallery.querySelector('[data-yg-video-btn]');
    const videoDivider = gallery.querySelector('[data-yg-video-divider]');
    const zoomBtn = gallery.querySelector('.product-gallery__zoom');
    const cursorEl = gallery.querySelector('.product-gallery__cursor');
    const mainPrevBtn = gallery.querySelector('[data-yg-main-prev]');
    const mainNextBtn = gallery.querySelector('[data-yg-main-next]');

    const isMobile = () => window.innerWidth < 700;
    const getVisibleCount = () => (isMobile() ? 4 : 6);
    const getImageSlides = () =>
      imageCarousel
        ? Array.from(imageCarousel.querySelectorAll(':scope > .product-gallery__media'))
        : [];
    const getVisibleImageSlides = () => getImageSlides().filter((item) => !item.hidden);
    const getVideoSlides = () =>
      videoCarousel
        ? Array.from(videoCarousel.querySelectorAll(':scope > .product-gallery__media'))
        : [];
    const getVisibleVideoSlides = () => getVideoSlides().filter((item) => !item.hidden);
    const getVisibleThumbItems = () => thumbItems.filter((item) => !item.hidden);

    let mode = 'image';
    let currentImageIndex = 0;
    let currentVideoIndex = 0;
    let windowStart = 0;

    function switchMode(newMode) {
      if (newMode === 'video' && getVisibleVideoSlides().length === 0) {
        newMode = 'image';
      }
      mode = newMode;
      if (mode === 'image') {
        if (imageCarousel) imageCarousel.hidden = false;
        if (videoCarousel) videoCarousel.hidden = true;
        if (videoBtn) videoBtn.classList.remove('is-active');
        if (zoomBtn) zoomBtn.style.display = '';
        if (cursorEl) cursorEl.hidden = false;
        updateCounterForImages();
      } else {
        if (imageCarousel) imageCarousel.hidden = true;
        if (videoCarousel) videoCarousel.hidden = false;
        if (videoBtn) videoBtn.classList.add('is-active');
        if (zoomBtn) zoomBtn.style.display = 'none';
        if (cursorEl) cursorEl.hidden = true;
        thumbItems.forEach((t) => t.setAttribute('aria-current', 'false'));
        currentVideoIndex = 0;
        updateCounterForVideos(0);
      }
      updateArrowState();
    }

    function updateCounterForImages() {
      const totalImageCount = getVisibleImageSlides().length;
      if (counterCurrent) counterCurrent.textContent = totalImageCount ? currentImageIndex + 1 : 0;
      if (counterTotal) counterTotal.textContent = totalImageCount;
    }

    function updateCounterForVideos(idx) {
      const totalVideoCount = getVisibleVideoSlides().length;
      if (counterCurrent) counterCurrent.textContent = totalVideoCount ? idx + 1 : 0;
      if (counterTotal) counterTotal.textContent = totalVideoCount;
    }

    function updateArrowState() {
      if (mode === 'image') {
        const totalImageCount = getVisibleImageSlides().length;
        const atStart = currentImageIndex <= 0;
        const atEnd = currentImageIndex >= totalImageCount - 1;
        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = atEnd;
        if (mainPrevBtn) mainPrevBtn.disabled = atStart;
        if (mainNextBtn) mainNextBtn.disabled = atEnd;
      } else {
        const totalVideoCount = getVisibleVideoSlides().length;
        const atStart = currentVideoIndex <= 0;
        const atEnd = currentVideoIndex >= totalVideoCount - 1;
        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = atEnd;
        if (mainPrevBtn) mainPrevBtn.disabled = atStart;
        if (mainNextBtn) mainNextBtn.disabled = atEnd;
      }
    }

    function selectImage(idx) {
      const imageSlides = getImageSlides();
      const visibleImageSlides = getVisibleImageSlides();
      const totalImageCount = visibleImageSlides.length;
      if (idx < 0 || idx >= totalImageCount) return;
      const selectedSlide = visibleImageSlides[idx];
      const carouselIndex = imageSlides.indexOf(selectedSlide);
      if (carouselIndex === -1) return;
      currentImageIndex = idx;

      if (mode !== 'image') switchMode('image');

      if (imageCarousel) {
        imageCarousel.dispatchEvent(
          new CustomEvent('control:select', {
            bubbles: true,
            cancelable: true,
            detail: { index: carouselIndex },
          })
        );
      }

      setActiveThumb(selectedSlide.dataset.mediaId);
      scrollThumbIntoView(idx);
      updateCounterForImages();
      updateArrowState();
    }

    function setActiveThumb(mediaId) {
      thumbItems.forEach((t) => t.setAttribute('aria-current', 'false'));
      const activeThumb = thumbItems.find((item) => item.dataset.mediaId === mediaId);
      activeThumb?.setAttribute('aria-current', 'true');
    }

    function updateThumbnailWindow() {
      const visibleItems = getVisibleThumbItems();
      const totalItems = visibleItems.length;
      const visible = getVisibleCount();
      const maxStart = Math.max(0, totalItems - visible);
      windowStart = Math.max(0, Math.min(windowStart, maxStart));

      thumbItems.forEach((item) => {
        item.style.display = 'none';
      });
      visibleItems.forEach((item, i) => {
        item.style.display = i >= windowStart && i < windowStart + visible ? '' : 'none';
      });

      const hiddenAfter = totalItems - (windowStart + visible);
      if (hiddenAfter > 0 && overflowEnd) {
        overflowEnd.hidden = false;
        overflowEndCount.textContent = '+' + hiddenAfter;
      } else if (overflowEnd) {
        overflowEnd.hidden = true;
      }

      if (windowStart > 0 && overflowStart) {
        overflowStart.hidden = false;
        overflowStartCount.textContent = '+' + windowStart;
      } else if (overflowStart) {
        overflowStart.hidden = true;
      }
    }

    function scrollThumbIntoView(imgIdx) {
      const visible = getVisibleCount();
      if (imgIdx < windowStart || imgIdx >= windowStart + visible) {
        windowStart = Math.max(0, imgIdx - Math.floor(visible / 2));
        updateThumbnailWindow();
      }
    }

    function selectVideo(idx) {
      const videoSlides = getVideoSlides();
      const visibleVideoSlides = getVisibleVideoSlides();
      const totalVideoCount = visibleVideoSlides.length;
      if (idx < 0 || idx >= totalVideoCount) return;
      const selectedSlide = visibleVideoSlides[idx];
      const carouselIndex = videoSlides.indexOf(selectedSlide);
      if (carouselIndex === -1) return;
      currentVideoIndex = idx;

      if (mode !== 'video') switchMode('video');

      if (videoCarousel) {
        videoCarousel.dispatchEvent(
          new CustomEvent('control:select', {
            bubbles: true,
            cancelable: true,
            detail: { index: carouselIndex },
          })
        );
      }

      updateCounterForVideos(idx);
      updateArrowState();
    }

    function navigatePrev() {
      if (mode === 'image') {
        selectImage(currentImageIndex - 1);
      } else {
        selectVideo(currentVideoIndex - 1);
      }
    }

    function navigateNext() {
      if (mode === 'image') {
        selectImage(currentImageIndex + 1);
      } else {
        selectVideo(currentVideoIndex + 1);
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', navigatePrev);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', navigateNext);
    }

    if (mainPrevBtn) {
      mainPrevBtn.addEventListener('click', navigatePrev);
    }

    if (mainNextBtn) {
      mainNextBtn.addEventListener('click', navigateNext);
    }

    thumbItems.forEach((item) => {
      item.addEventListener('click', () => {
        const visibleIndex = getVisibleThumbItems().indexOf(item);
        if (visibleIndex !== -1) selectImage(visibleIndex);
      });
    });

    if (videoBtn) {
      videoBtn.addEventListener('click', () => {
        if (mode === 'video') {
          switchMode('image');
          selectImage(currentImageIndex);
        } else {
          switchMode('video');
        }
      });
    }

    if (imageCarousel) {
      imageCarousel.addEventListener('carousel:change', (event) => {
        if (mode !== 'image') return;
        const selectedSlide = event.detail.slide || getImageSlides()[event.detail.index];
        const idx = getVisibleImageSlides().indexOf(selectedSlide);
        if (idx === -1) return;
        currentImageIndex = idx;
        setActiveThumb(selectedSlide.dataset.mediaId);
        scrollThumbIntoView(idx);
        updateCounterForImages();
        updateArrowState();
      });
    }

    if (videoCarousel) {
      videoCarousel.addEventListener('carousel:change', (event) => {
        if (mode !== 'video') return;
        const selectedSlide = event.detail.slide || getVideoSlides()[event.detail.index];
        const idx = getVisibleVideoSlides().indexOf(selectedSlide);
        if (idx === -1) return;
        currentVideoIndex = idx;
        updateCounterForVideos(idx);
        updateArrowState();
      });
    }

    function refreshForVariant() {
      const visibleImageSlides = getVisibleImageSlides();
      const visibleThumbItems = getVisibleThumbItems();
      const selectedSlide = imageCarousel?.selectedSlide;
      const selectedVisibleIndex = visibleImageSlides.indexOf(selectedSlide);

      mode = 'image';
      currentImageIndex = selectedVisibleIndex === -1 ? 0 : selectedVisibleIndex;
      currentVideoIndex = 0;
      windowStart = 0;

      if (imageCarousel) imageCarousel.hidden = false;
      if (videoCarousel) videoCarousel.hidden = true;
      if (videoBtn) {
        videoBtn.hidden = getVisibleVideoSlides().length === 0;
        videoBtn.classList.remove('is-active');
      }
      if (videoDivider) videoDivider.hidden = getVisibleVideoSlides().length === 0;
      if (zoomBtn) zoomBtn.style.display = '';
      if (cursorEl) cursorEl.hidden = false;

      thumbControls.dataset.totalImages = String(visibleImageSlides.length);
      thumbControls.dataset.totalVideos = String(getVisibleVideoSlides().length);
      visibleThumbItems.forEach((item, index) => {
        item.dataset.ygThumbIndex = String(index);
      });

      const activeSlide = visibleImageSlides[currentImageIndex];
      setActiveThumb(activeSlide?.dataset.mediaId);
      updateThumbnailWindow();
      updateCounterForImages();
      updateArrowState();
    }

    function syncInitialMedia() {
      const initialMediaId = imageCarousel?.dataset.initialMediaId;
      const initialVisibleIndex = initialMediaId
        ? getVisibleImageSlides().findIndex((slide) => slide.dataset.mediaId === initialMediaId)
        : 0;

      selectImage(initialVisibleIndex >= 0 ? initialVisibleIndex : 0);
    }

    gallery.addEventListener('product-gallery:variant-filter', refreshForVariant);
    refreshForVariant();

    customElements.whenDefined('media-carousel').then(() => {
      requestAnimationFrame(syncInitialMedia);
    });

    window.addEventListener('resize', () => updateThumbnailWindow());
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-anchor-item"] && !Shopify.designMode) return;
  try {
    class YGAnchorItem extends HTMLElement {
      #observedSection = null;
      static observer = null;
      static sectionToItem = new Map();
      static isScroll = false;

      constructor() {
        super();
        this.itemClick = this.itemClick.bind(this);
        this.sections = null;
      }

      connectedCallback() {
        this.sections = document.querySelectorAll('#main .shopify-section');
        this.addEventListener('click', this.itemClick);

        const sectionNumber = Number(this.getAttribute('data-section-number') || 0);
        if (!this.sections?.length || !Number.isFinite(sectionNumber) || sectionNumber <= 0) return;

        const section = this.sections[sectionNumber - 1];
        if (!section) return;

        this.#observedSection = section;
        YGAnchorItem.#ensureObserver();
        YGAnchorItem.sectionToItem.set(section, this);
        YGAnchorItem.observer.observe(section);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);

        if (this.#observedSection && YGAnchorItem.observer) {
          YGAnchorItem.sectionToItem.delete(this.#observedSection);
          YGAnchorItem.observer.unobserve(this.#observedSection);
        }
      }

      static #ensureObserver() {
        if (YGAnchorItem.observer) return;

        YGAnchorItem.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const item = YGAnchorItem.sectionToItem.get(entry.target);
              if (!YGAnchorItem.isScroll) {
                item && item.setActiveFromObserver();
              }
            });
          },
          {
            root: null,
            threshold: 0.01,
            rootMargin: '-20% 0px -70% 0px',
          }
        );
      }

      setActiveFromObserver() {
        let id = this.getAttribute('data-id');
        let $anchorList;
        if (id) {
          $anchorList = this.parentElement
            ? Array.from(document.querySelectorAll(`yg-anchor-item[data-id="${id}"]`))
            : [];
        } else {
          $anchorList = this.parentElement
            ? Array.from(this.parentElement.querySelectorAll('yg-anchor-item'))
            : [];
        }

        $anchorList.forEach((el, index) => {
          el.classList.toggle('active', el.getAttribute('data-section-number') === this.getAttribute('data-section-number'));

          if (el === this) {
            this.labelClick(index);
          }
        });

        document.dispatchEvent(new CustomEvent('YG:anchor-change', {
          bubbles: true,
        }));
      }

      labelClick(index) {
        // 添加新的活动状态
        const parent = this.parentElement;
        if (parent && this.isScrollable(parent)) {
          const containerRect = parent.getBoundingClientRect();
          const targetRect = this.getBoundingClientRect();
          const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 260;

          parent.scrollTo({
            left: scrollLeft,
            behavior: 'smooth',
          });
        }
      }

      isScrollable(el) {
        if (!el) return false;

        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        const overflowX = style.overflowX;

        const canScrollVertically =
          (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
        const canScrollHorizontally =
          (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;

        return canScrollVertically || canScrollHorizontally;
      }

      itemClick() {
        const sectionNumber = this.getAttribute('data-section-number');
        YGAnchorItem.isScroll = true;
        this.setActiveFromObserver();
        if (sectionNumber == 0) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        } else {
          const section = this.sections[sectionNumber - 1];
          if (!section) return;
          const offsetTop = section.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }

        setTimeout(() => {
          YGAnchorItem.isScroll = false;
        }, 600);
      }
    }
    if (!window.customElements.get('yg-anchor-item')) {
      window.customElements.define('yg-anchor-item', YGAnchorItem);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-collapse-button"] && !Shopify.designMode) return;
  try {
    class YGCollapseButton extends HTMLElement {
    #sectionEl;
    constructor() {
        super()
        this.itemClick = this.itemClick.bind(this)
    }

    get $sectionEl() {
      // if (this.#sectionEl) return this.#sectionEl

      this.#sectionEl = {
        'targetEl': document.querySelector(`.${this.getAttribute('data-target-class')}`),
        'buttonLabel': this.querySelector('.yg-link-label')
      }

      return this.#sectionEl
    }
    connectedCallback() {
        if (!this.$sectionEl['targetEl']) return
        this.init()
        this.addEventListener('click', this.itemClick);
        this.$sectionEl['targetEl'].addEventListener('click', ()=>{this.init()})
    }
    disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);
    }

    init() {
      const target = this.$sectionEl['targetEl'];
      const visibleRows = Number(this.getAttribute('data-visible-rows') || 0);
      const rows = target.querySelectorAll('.row');

      if (!target.classList.contains('yg-collapse-target-el')) {
        target.classList.add('yg-collapse-target-el');
      }

      if (visibleRows && rows.length <= visibleRows) {
        target.style.height = 'auto';
        this.hidden = true;
        return;
      }

      this.hidden = false;

      if (target.hasAttribute('open')) {
        target.style.height = 'auto';
      } else {
        target.style.height = this.getCollapsedHeight() + 'px';
      }
    }

    getCollapsedHeight() {
      const target = this.$sectionEl['targetEl'];
      const visibleRows = Number(this.getAttribute('data-visible-rows') || 0);
      if (!visibleRows) return 0;

      const rows = Array.from(target.querySelectorAll('.row')).filter((row) => {
        return row.offsetParent !== null;
      });
      const lastVisibleRow = rows[Math.min(visibleRows, rows.length) - 1];
      if (!lastVisibleRow) return target.scrollHeight;

      const targetRect = target.getBoundingClientRect();
      const rowRect = lastVisibleRow.getBoundingClientRect();
      return Math.max(0, rowRect.bottom - targetRect.top);
    }

    openSection() {
      let target = this.$sectionEl['targetEl'];
      let buttonLabel = this.$sectionEl['buttonLabel'];

      // 先把高度设为当前像素值，再过渡到内容高度
      target.style.height = target.offsetHeight + 'px';
      
      // 强制浏览器重新计算一次布局，确保过渡生效
      target.offsetHeight;

      const endHeight = target.scrollHeight;
      target.style.height = endHeight + 'px';
      target.setAttribute('open', '');
      this.setAttribute('open', '');
      buttonLabel.innerText = this.getAttribute("data-less-label")

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;
        target.style.height = 'auto'; // 过渡结束后改为 auto，后续内容高度变化自动适应
        target.removeEventListener('transitionend', onTransitionEnd);
      };

      target.addEventListener('transitionend', onTransitionEnd);
    }

    closeSection() {
      const target = this.$sectionEl['targetEl'];
      const buttonLabel = this.$sectionEl['buttonLabel'];

      // 防止重复关闭
      if (!target.hasAttribute('open')) return;

      this.removeAttribute('open');
      buttonLabel.innerText = this.getAttribute("data-more-label")

      // 从 auto 变成具体高度，再过渡到 0
      if (getComputedStyle(target).height === 'auto') {
        target.style.height = target.scrollHeight + 'px';
      } else if (!target.style.height || target.style.height === '0px') {
        target.removeAttribute('open');
        target.style.height = this.getCollapsedHeight() + 'px';
        return;
      }

      // 强制重新计算
      target.offsetHeight;

      target.style.height = this.getCollapsedHeight() + 'px';
      target.removeAttribute('open');
      this.removeAttribute('open');
      buttonLabel.innerText = this.getAttribute("data-more-label")
    }

    itemClick() {
      const target = this.$sectionEl['targetEl'];
      if (target.hasAttribute('open')) {
        this.closeSection();
      } else {
        this.openSection();
      }
    }
  }
  if (!window.customElements.get('yg-collapse-button')) {
    window.customElements.define('yg-collapse-button', YGCollapseButton)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-dot-v1"] && !Shopify.designMode) return;
  try {
    class YGDotV1 extends HTMLElement {
    static activeLockOwner = null;
    static lockedScrollY = 0;
    static mobileTransitionDuration = 280;

    constructor() {
      super();
      this.handleButtonClick = this.handleButtonClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleOverlayClick = this.handleOverlayClick.bind(this);
    }

    connectedCallback() {
      if (this.isConnectedSetup) return;

      this.isConnectedSetup = true;
      this.buttonElement = this.querySelector('.yg-dot-v1__button');
      this.cardShellElement = this.querySelector('.yg-dot-v1__card-shell');
      this.closeButtonElement = this.querySelector('.yg-dot-v1__close');
      this.mobileOverlayElement = this.querySelector('.yg-dot-v1__mobile-overlay');
      this.portalStyleSourceElement = this.closest('yg-banner-tabs-v1');
      this.cardShellOriginParent = this.cardShellElement?.parentNode || null;
      this.cardShellOriginNextSibling = this.cardShellElement?.nextSibling || null;
      this.overlayOriginParent = this.mobileOverlayElement?.parentNode || null;
      this.overlayOriginNextSibling = this.mobileOverlayElement?.nextSibling || null;

      this.button?.addEventListener('click', this.handleButtonClick);
      this.closeButton?.addEventListener('click', this.handleCloseClick);
      this.mobileOverlay?.addEventListener('click', this.handleOverlayClick);
      window.addEventListener('resize', this.handleResize, { passive: true });
      document.addEventListener('click', this.handleDocumentClick);

      if (this.isDefaultOpen) {
        requestAnimationFrame(() => this.open(false));
      } else {
        this.close(false);
      }
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleButtonClick);
      this.closeButton?.removeEventListener('click', this.handleCloseClick);
      this.mobileOverlay?.removeEventListener('click', this.handleOverlayClick);
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('click', this.handleDocumentClick);
      this.clearMobileCloseTimer();
      this.hideMobileLayer();
      if (this.mobileOverlay) {
        this.mobileOverlay.hidden = true;
      }
      if (this.cardShell) {
        this.cardShell.hidden = true;
      }
      this.restoreMobileLayer();
      YGDotV1.unlockBodyScroll(this);
      this.isConnectedSetup = false;
    }

    get button() {
      return this.buttonElement || this.querySelector('.yg-dot-v1__button');
    }

    get cardShell() {
      return this.cardShellElement || this.querySelector('.yg-dot-v1__card-shell');
    }

    get closeButton() {
      return this.closeButtonElement || this.querySelector('.yg-dot-v1__close');
    }

    get mobileOverlay() {
      return this.mobileOverlayElement || this.querySelector('.yg-dot-v1__mobile-overlay');
    }

    get isDefaultOpen() {
      return this.dataset.defaultOpen === 'true';
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    handleButtonClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.toggle();
    }

    handleDocumentClick(event) {
      if (!this.isOpen || this.isEventInside(event.target)) return;
      this.close();
    }

    handleCloseClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.close();
    }

    handleOverlayClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.close();
    }

    handleResize() {
      if (!this.isOpen) return;

      if (this.isMobile) {
        this.syncPortalStyles();
        this.mountMobileLayer();
        this.showMobileLayer();
        YGDotV1.lockBodyScroll(this);
      } else {
        this.hideMobileLayer();
        if (this.mobileOverlay) {
          this.mobileOverlay.hidden = true;
        }
        this.restoreMobileLayer();
        YGDotV1.unlockBodyScroll(this);
        if (this.cardShell) {
          this.cardShell.hidden = false;
        }
      }

      this.updatePlacement();
    }

    get isMobile() {
      return window.innerWidth <= 699;
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open(emitEvent = true) {
      this.clearMobileCloseTimer();

      if (this.isMobile) {
        this.syncPortalStyles();
        this.mountMobileLayer();
      }

      if (this.cardShell) {
        this.cardShell.hidden = false;
      }

      this.classList.add('is-open');
      this.button?.setAttribute('aria-expanded', 'true');
      if (this.isMobile) {
        this.showMobileLayer();
        YGDotV1.lockBodyScroll(this);
      } else {
        this.hideMobileLayer();
        if (this.mobileOverlay) {
          this.mobileOverlay.hidden = true;
        }
        this.restoreMobileLayer();
      }
      this.updatePlacement();
      requestAnimationFrame(() => this.updatePlacement());

      if (emitEvent) {
        this.dispatchState();
      }
    }

    close(emitEvent = true) {
      this.classList.remove('is-open');
      this.removeAttribute('data-placement-x');
      this.removeAttribute('data-placement-y');
      this.style.removeProperty('--dot-card-shift-x');
      this.style.removeProperty('--dot-card-shift-y');
      this.button?.setAttribute('aria-expanded', 'false');
      YGDotV1.unlockBodyScroll(this);

      if (this.isMobile || this.isUsingMobileLayer) {
        this.hideMobileLayer();
        this.queueMobileRestore();
      } else if (this.cardShell) {
        this.cardShell.hidden = true;
      }

      if (emitEvent) {
        this.dispatchState();
      }
    }

    reset() {
      if (this.isDefaultOpen) {
        this.open(false);
      } else {
        this.close(false);
      }
    }

    updatePlacement() {
      if (!this.cardShell || this.cardShell.hidden) return;

      const viewportWidth = document.documentElement.clientWidth;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const rect = this.getBoundingClientRect();
      const safeSpace = 16;
      const isMobile = window.innerWidth <= 699;
      this.style.setProperty('--dot-card-shift-x', '0px');
      this.style.setProperty('--dot-card-shift-y', '0px');

      if (isMobile) {
        this.removeAttribute('data-placement-y');
        return;
      } else {
        const cardRect = this.cardShell.getBoundingClientRect();
        const spaceRight = viewportWidth - rect.right - safeSpace;
        const spaceLeft = rect.left - safeSpace;
        const shouldOpenLeft = spaceRight < cardRect.width && spaceLeft >= spaceRight;

        this.dataset.placementX = shouldOpenLeft ? 'left' : 'right';

        const placedCardRect = this.cardShell.getBoundingClientRect();
        let shiftX = 0;

        if (placedCardRect.left < safeSpace) {
          shiftX = safeSpace - placedCardRect.left;
        } else if (placedCardRect.right > viewportWidth - safeSpace) {
          shiftX = (viewportWidth - safeSpace) - placedCardRect.right;
        }

        this.style.setProperty('--dot-card-shift-x', `${shiftX}px`);

        const centerY = rect.top + (rect.height / 2);
        const halfHeight = placedCardRect.height / 2;
        let shiftY = 0;

        if (centerY - halfHeight < safeSpace) {
          shiftY = safeSpace - (centerY - halfHeight);
        } else if (centerY + halfHeight > viewportHeight - safeSpace) {
          shiftY = (viewportHeight - safeSpace) - (centerY + halfHeight);
        }

        this.style.setProperty('--dot-card-shift-y', `${shiftY}px`);
      }
    }

    isEventInside(target) {
      return this.contains(target) || this.cardShell?.contains(target) || this.mobileOverlay === target;
    }

    get isUsingMobileLayer() {
      return this.cardShell?.parentNode === document.body;
    }

    mountMobileLayer() {
      if (!this.isMobile) return;

      this.syncPortalStyles();

      if (this.mobileOverlay && this.mobileOverlay.parentNode !== document.body) {
        document.body.appendChild(this.mobileOverlay);
      }

      if (this.cardShell && this.cardShell.parentNode !== document.body) {
        document.body.appendChild(this.cardShell);
      }
    }

    restoreMobileLayer() {
      this.restoreNode(this.mobileOverlay, this.overlayOriginParent, this.overlayOriginNextSibling);
      this.restoreNode(this.cardShell, this.cardShellOriginParent, this.cardShellOriginNextSibling);
    }

    restoreNode(node, parent, nextSibling) {
      if (!node || !parent || node.parentNode === parent) return;

      if (nextSibling && nextSibling.parentNode === parent) {
        parent.insertBefore(node, nextSibling);
      } else {
        parent.appendChild(node);
      }
    }

    showMobileLayer() {
      if (!this.isMobile) return;

      if (this.mobileOverlay) {
        this.mobileOverlay.hidden = false;
      }

      if (this.cardShell) {
        this.cardShell.hidden = false;
      }

      requestAnimationFrame(() => {
        if (!this.isOpen || !this.isMobile) return;
        this.mobileOverlay?.classList.add('is-visible');
        this.cardShell?.classList.add('is-mobile-open');
      });
    }

    hideMobileLayer() {
      this.mobileOverlay?.classList.remove('is-visible');
      this.cardShell?.classList.remove('is-mobile-open');
    }

    queueMobileRestore() {
      this.clearMobileCloseTimer();
      this.mobileCloseTimer = window.setTimeout(() => {
        this.mobileCloseTimer = null;

        if (this.isOpen) return;

        if (this.mobileOverlay) {
          this.mobileOverlay.hidden = true;
        }

        if (this.cardShell) {
          this.cardShell.hidden = true;
        }

        this.restoreMobileLayer();
      }, YGDotV1.mobileTransitionDuration);
    }

    clearMobileCloseTimer() {
      if (!this.mobileCloseTimer) return;
      window.clearTimeout(this.mobileCloseTimer);
      this.mobileCloseTimer = null;
    }

    syncPortalStyles() {
      if (!this.cardShell || !this.portalStyleSourceElement) return;

      const sourceStyles = window.getComputedStyle(this.portalStyleSourceElement);

      Array.from(sourceStyles).forEach((propertyName) => {
        if (!propertyName.startsWith('--')) return;

        const propertyValue = sourceStyles.getPropertyValue(propertyName);
        if (!propertyValue) return;

        this.cardShell.style.setProperty(propertyName, propertyValue);
      });
    }

    static lockBodyScroll(owner) {
      if (YGDotV1.activeLockOwner === owner) return;

      if (!YGDotV1.activeLockOwner) {
        YGDotV1.lockedScrollY = window.scrollY || window.pageYOffset || 0;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${YGDotV1.lockedScrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      }

      YGDotV1.activeLockOwner = owner;
    }

    static unlockBodyScroll(owner) {
      if (YGDotV1.activeLockOwner !== owner) return;

      YGDotV1.activeLockOwner = null;
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('left');
      document.body.style.removeProperty('right');
      document.body.style.removeProperty('width');
      window.scrollTo(0, YGDotV1.lockedScrollY);
    }

    dispatchState() {
      this.dispatchEvent(new CustomEvent('yg:dot-toggle', {
        bubbles: true,
        detail: {
          dot: this,
          isOpen: this.isOpen,
        },
      }));
    }
  }

  if (!window.customElements.get('yg-dot-v1')) {
    window.customElements.define('yg-dot-v1', YGDotV1);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-dropdown"] && !Shopify.designMode) return;
  try {
    class YGDropdown extends YGUtils {
    #dropdownGroup;
    static #groupRegistry = new Map();

    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
      this.debouncedResize = this.debounce(() => this.setContentContainerHeight(), 100);
    }

    #manageGroupRegistry(action) {
      const groupID = this.dataset.group;
      if (!groupID) return action === 'get' ? null : undefined;

      switch (action) {
        case 'add':
          if (!YGDropdown.#groupRegistry.has(groupID)) {
            YGDropdown.#groupRegistry.set(groupID, new Set());
          }
          YGDropdown.#groupRegistry.get(groupID).add(this);
          break;
        case 'remove':
          if (YGDropdown.#groupRegistry.has(groupID)) {
            YGDropdown.#groupRegistry.get(groupID).delete(this);
          }
          break;
        case 'get':
          const groupDropdowns = YGDropdown.#groupRegistry.get(groupID);
          this.#dropdownGroup = groupDropdowns ? Array.from(groupDropdowns) : null;
          return this.#dropdownGroup;
      }
    }

    get dropdownGroup() {
      if (this.#dropdownGroup) return this.#dropdownGroup;
      return this.#manageGroupRegistry('get');
    }

    connectedCallback() {
      this.#manageGroupRegistry('add');

      setTimeout(() => {
        if (this.dropdownGroup?.length > 0) {
          this.dropdownGroup[0]?.openDropdown();
        }
      }, 60);
      this.titleContainer = this.querySelector('.yg-dropdown-title-container');
      if (this.titleContainer) {
        this.titleContainer.addEventListener('click', this.itemClick);
        window.addEventListener('resize', this.debouncedResize);
        this.setContentContainerHeight();
      }
    }

    disconnectedCallback() {
      this.#manageGroupRegistry('remove');

      if (this.titleContainer) {
        this.titleContainer.removeEventListener('click', this.itemClick);
      }
      if (this.debouncedResize) {
        window.removeEventListener('resize', this.debouncedResize);
      }
    }
    itemClick() {
      this.setContentContainerHeight();
      let group = this.dropdownGroup;
      if (group && Array.isArray(group) && this.hasAttribute('open')) {
        if (!this.hasAttribute('data-accordion') && group.length > 1) {
          this.closeDropdown();
        }
        return;
      }

      this.hasAttribute('open') ? this.closeDropdown() : this.openDropdown();
    }

    openDropdown() {
      let group = this.dropdownGroup;
      if (group && Array.isArray(group)) {
        group.forEach((dropdown) => {
          if (dropdown !== this) {
            dropdown.closeDropdown();
          }
        });
      }

      this.setAttribute('open', '');
      document.dispatchEvent(
        new CustomEvent('YG:dropdown-open', {
          bubbles: true,
          composed: true,
          detail: {
            id: this.getAttribute('data-id'),
          },
        })
      );
    }

    closeDropdown() {
      this.removeAttribute('open');
    }

    setContentContainerHeight() {
      let contentContainer = this.querySelector('.yg-dropdown-content-container');
      let content = this.querySelector('.yg-dropdown-content');
      if (contentContainer && content) {
        contentContainer.style.setProperty('--height', `${content.getBoundingClientRect().height}px`);
      }
    }
  }
  if (!window.customElements.get('yg-dropdown')) {
    window.customElements.define('yg-dropdown', YGDropdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      const deferOnMobile =
        this.dataset.deferUntilActiveSlide === 'true' &&
        window.matchMedia('(max-width: 699px)').matches;

      if (deferOnMobile) return;

      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-open-popup"] && !Shopify.designMode) return;
  try {
    class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.handleActivate = this.handleActivate.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    getDirectPopupTemplate() {
      return Array.from(this.children).find((child) => child.matches('template, .yg-popup-template')) || null;
    }

    connectedCallback() {
      this.sectionsEl = {
        popupTemplate: this.getDirectPopupTemplate(),
      };

      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'button');
      }

      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }

      this.addEventListener('click', this.handleActivate);
      this.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleActivate);
      this.removeEventListener('keydown', this.handleKeydown);
    }

    getPopupTemplate() {
      if (this.sectionsEl.popupTemplate) {
        return this.sectionsEl.popupTemplate;
      }

      if (!this.dataset.popupId) {
        return null;
      }

      return document.getElementById(`yg-popup-template-${this.dataset.popupId}`);
    }

    handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      this.handleActivate();
    }

    handleActivate() {
      const popupTemplate = this.getPopupTemplate();

      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }

      this.dispatchEvent(
        new CustomEvent('YG:openPopup', {
          bubbles: true,
          detail: {
            popupTemplate,
            popupClass: this.dataset.popupClass,
            closeBtnClass: this.dataset.closeBtnClass,
          },
        })
      );
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-popup"] && !Shopify.designMode) return;
  try {
    class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    // 优化：缓存并懒加载元素，只查询一次，提高性能和可维护性
    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        close: this.querySelector('.yg-popup-box-close'),
        'content-inner': this.querySelector('.yg-popup-box-content-inner'),
        body: document.body,
      };

      return this._sectionsEl;
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', this.openPopup);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', this.openPopup);
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};

      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      this.sectionsEl['close'].classList.add(`${closeBtnClass}`);
      this.classList.add(`${popupClass}`);
      this.sectionsEl['content-inner'].innerHTML = popupTemplate.innerHTML;
      this.sectionsEl['body'].style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.sectionsEl['content-inner'].innerHTML = '';
        this.sectionsEl['body'].style.overflow = 'auto';
        this.sectionsEl['close'].className = 'yg-popup-box-close';
        this.className = 'yg-popup-box';
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-progress-bar"] && !Shopify.designMode) return;
  try {
    class YGProgressBar extends HTMLElement {
    #videoListenersAttached = false;

    constructor() {
      super();
      this.video = null;
      this.animationFrame = null;
    }

    connectedCallback() {
    }

    get isCircle() {
      return this.classList.contains('yg-progress-circle');
    }

    get circleProgressElement() {
      return this.querySelector('.circle-progress');
    }

    findVideo() {
      let isMobile = window.innerWidth < 699;
      let id = this.getAttribute('data-id');
      if (isMobile && this.getAttribute('data-mobile-id')) {
        id = this.getAttribute('data-mobile-id');
      }
      if (!id) return null;

      return document.querySelector(`yg-video[data-id="${id}"]`);
    }

    getVideoElement(videoComponent) {
      if (!videoComponent) return null;
      return videoComponent.querySelector('.yg-video-iframe');
    }

    syncWithVideo() {
      if (!this.video) return;

      const videoEl = this.getVideoElement(this.video);
      if (!videoEl) return;

      const duration = this.video.duration || videoEl.duration || 0;
      const currentTime = videoEl.currentTime || 0;

      if (duration > 0) {
        const progress = (currentTime / duration) * 100;
        
        if (this.isCircle) {
          this.syncCircleProgress(progress);
        } else {
          this.style.setProperty('--progress-width', `${progress}%`);
        }
      }
    }

    syncCircleProgress(progress) {
      const circleEl = this.circleProgressElement;
      if (!circleEl) return;

      const circumference = parseFloat(getComputedStyle(this).getPropertyValue('--circle-circumference')) || 100;
      const dashArray = (progress / 100) * circumference;
      circleEl.style.strokeDasharray = `${dashArray} ${circumference}`;
    }

    startProgress() {
      const id = this.getAttribute('data-id');
      this.video = this.findVideo();

      if (this.video) {
        this.startVideoProgress();
      } else {
        this.startAnimationProgress();
      }
    }

    startAnimationProgress() {
      const id = this.getAttribute('data-id');
      this.classList.add('start-progress');

      if (this.isCircle) {
        const circleEl = this.circleProgressElement;
        if (circleEl) {
          const style = getComputedStyle(this);
          const duration = parseFloat(style.getPropertyValue('--duration')) || 10;
          const circumference = parseFloat(style.getPropertyValue('--circle-circumference')) || 100;
          
          let startTime = null;
          
          const animate = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const elapsed = (timestamp - startTime) / 1000;
            const progress = Math.min(elapsed / duration, 1);
            
            const dashArray = progress * circumference;
            circleEl.style.strokeDasharray = `${dashArray} ${circumference}`;
            
            if (progress < 1) {
              this.animationFrame = requestAnimationFrame(animate);
            } else {
              this.stopProgress(true);
            }
          };
          
          this.animationFrame = requestAnimationFrame(animate);
        }
        return;
      }

      let handleAnimationEnd = () => {
        this.stopProgress(true);
        this.removeEventListener('animationend', handleAnimationEnd);
      };

      this.addEventListener('animationend', handleAnimationEnd);
    }

    startVideoProgress() {
      this.classList.add('video-sync');

      const videoEl = this.getVideoElement(this.video);
      if (!videoEl) {
        this.#waitForVideo();
        return;
      }

      this.#initVideoListeners(videoEl);

      if (!videoEl.paused) {
        this.classList.add('playing');
        this.#startVideoUpdate(videoEl);
      }
    }

    #waitForVideo() {
      const observer = new MutationObserver(() => {
        const videoEl = this.getVideoElement(this.video);
        if (videoEl) {
          observer.disconnect();
          this.#initVideoListeners(videoEl);
          if (!videoEl.paused) {
            this.classList.add('playing');
            this.#startVideoUpdate(videoEl);
          }
        }
      });
      observer.observe(this.video, { childList: true, subtree: true });
    }

    #initVideoListeners(videoEl) {
      if (this.#videoListenersAttached) return;
      this.#videoListenersAttached = true;

      videoEl.addEventListener('play', () => {
        this.classList.add('playing');
        this.#startVideoUpdate(videoEl);
      });

      videoEl.addEventListener('pause', () => {
        this.classList.remove('playing');
        this.#stopVideoUpdate();
      });

      videoEl.addEventListener('ended', () => {
        this.stopProgress(true);
      });

      videoEl.addEventListener('timeupdate', () => {
        this.syncWithVideo();
      });
    }

    #startVideoUpdate(videoEl) {
      this.#stopVideoUpdate();
      const updateProgress = () => {
        this.syncWithVideo();
        if (!videoEl.paused && !videoEl.ended) {
          this.animationFrame = requestAnimationFrame(updateProgress);
        }
      };
      updateProgress();
    }

    #stopVideoUpdate() {
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }
    }

    stopProgress(completed = false) {
      this.classList.remove('start-progress', 'playing', 'video-sync');

      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }

      if (this.isCircle && !completed) {
        const circleEl = this.circleProgressElement;
        if (circleEl) {
          const circumference = parseFloat(getComputedStyle(this).getPropertyValue('--circle-circumference')) || 100;
          circleEl.style.strokeDasharray = `0 ${circumference}`;
        }
      }

      if (completed) {
        const id = this.getAttribute('data-id');
        document.dispatchEvent(new CustomEvent('YG:progress-end', {
          bubbles: true,
          composed: true,
          detail: { id }
        }));
      }
    }
  }

  if (!window.customElements.get('yg-progress-bar')) {
    window.customElements.define('yg-progress-bar', YGProgressBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-tabs"] && !Shopify.designMode) return;
  try {
    class YGTabsTitle extends YGUtils {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this._resizeTimer = null;
    }

    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'title-list': Array.from(this.children),
        'content-list': Array.from(
          document.querySelector(`yg-tabs-content[data-id='${this.dataset.id}']`)?.children || []
        ),
      };

      return this._sectionsEl;
    }

    connectedCallback() {
      this.initTabs();
      this.addEventListener('click', this.handleClick);
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      window.removeEventListener('resize', this.handleResize);
      if (this._resizeTimer) {
        window.clearTimeout(this._resizeTimer);
        this._resizeTimer = null;
      }
    }

    handleClick(e) {
      let item = e.target.closest('.tab-title');
      if (item) {
        let i = this.sectionsEl['title-list'].indexOf(item);
        this.itemClick(item, i);
      }
    }

    handleResize() {
      if (this._resizeTimer) {
        window.clearTimeout(this._resizeTimer);
      }

      this._resizeTimer = window.setTimeout(() => {
        this._resizeTimer = null;
        this.updateStyle();
      }, 120);
    }

    initTabs() {
      const titleList = this.sectionsEl['title-list'];
      const contentList = this.sectionsEl['content-list'];
      const maxIndex = Math.max(0, titleList.length - 1);
      const defaultIndex = Math.max(0, Math.min(Number(this.dataset.activeIndex || 0), maxIndex));

      titleList?.forEach((el, i) => {
        if (!el.classList.contains('tab-title')) {
          el.classList.add('tab-title');
        }

        el.classList.remove('is-active');
        if (i == defaultIndex) {
          el.classList.add('is-active');
        }
      });
      this.updateStyle(titleList[defaultIndex] || titleList[0]);

      contentList.forEach((el, i) => {
        if (!el.classList.contains('tab-content')) {
          el.classList.add('tab-content');
        }

        el.classList.remove('is-active');
        if (i == defaultIndex) el.classList.add('is-active');
      });
    }

    itemClick(el, i) {
      // 如果已经激活则直接返回
      if (el.classList.contains('is-active')) return;

      el.scrollIntoView({ behavior: 'smooth', inline: 'center', container: 'nearest' });
      this.toggleClass(el, i);
    }

    toggleClass(el, i) {
      // 处理标题激活状态
      this.sectionsEl['title-list'].forEach((item) => {
        item.classList.remove('is-active');
      });
      el.classList.add('is-active');
      this.updateStyle(el);

      // 处理内容激活状态
      this.sectionsEl['content-list'].forEach((item) => {
        item.classList.remove('is-active');
      });
      if (this.sectionsEl['content-list'][i]) this.sectionsEl['content-list'][i].classList.add('is-active');
    }

    updateStyle(el = null) {
      let itemEl = el || this.querySelector('.is-active');

      if (!itemEl) return;
      let left = itemEl.offsetLeft;
      let width = itemEl.offsetWidth;
      this.style.setProperty('--scroll-item-left', `${left}px`);
      this.style.setProperty('--scroll-item-width', `${width}px`);
    }
  }
  if (!window.customElements.get('yg-tabs-title')) {
    window.customElements.define('yg-tabs-title', YGTabsTitle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-variant-product-key-features"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-key-features')) {
    customElements.define(
      'variant-key-features',
      class VariantKeyFeatures extends HTMLElement {
        connectedCallback() {
          this.abortController = new AbortController();
          this.productForm = document.forms[this.getAttribute('form')];
          this.productForm?.addEventListener('variant:change', this.onVariantChange.bind(this), {
            signal: this.abortController.signal,
          });
          this.showVariant(this.getAttribute('selected-variant-id'));
        }

        disconnectedCallback() {
          this.abortController?.abort();
        }

        onVariantChange(event) {
          const variantId = event.detail.variant?.id;
          if (variantId) this.showVariant(String(variantId));
        }

        showVariant(variantId) {
          const panels = Array.from(this.querySelectorAll('[data-variant-content]'));
          const matchingPanel = panels.find((panel) => panel.dataset.variantContent === String(variantId));
          const activePanel = matchingPanel || panels[0];

          panels.forEach((panel) => {
            panel.hidden = panel !== activePanel;
          });

          if (activePanel) this.setAttribute('selected-variant-id', activePanel.dataset.variantContent);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLazyLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.loop = this.getAttribute('data-loop');
      this.type = this.getAttribute('data-type');
      this.enablePause = this.getAttribute('data-enable-pause') === 'true';
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get videoButton() {
      return this.querySelector('.yg-video-button');
    }

    get playVideoButton() {
      return this.querySelector('.yg-video-button .yg-play');
    }

    get pauseVideoButton() {
      return this.querySelector('.yg-video-button .yg-pause');
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      this.pauseVideoButton?.addEventListener('click', ()=>this.pauseVideo());
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getLazyLoader().observe(this);
      }

      // Warm HTML5 video only when this component is close to the viewport.
      this.scheduleHtml5VideoWarmup();
    }

    disconnectedCallback() {
      this.playVideoButton?.removeEventListener('click', this.playVideoClick);
      this.__ygHtml5WarmupObserver?.disconnect();
      this.__ygHtml5WarmupObserver = null;
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.template,
            },
          })
        );

        return;
      }

      this.image?.classList.add('close');
      this.switcherVideoButtonState("play")
      if (!this.videoContainer) {
        this.appendChild(this.template?.content.cloneNode(true));
      }

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');

        this.videoContainer.classList.remove('close');
        videos.forEach(video => {
          video.play();
          // 监听video进度，当进度到达100%，且不循环时切换按钮
          video.addEventListener('timeupdate', () => {
            if (
              video.duration &&
              video.currentTime >= video.duration &&
              this.loop == 'false'
            ) {
              this.pauseVideo();
              this.switcherVideoButtonState("pause");
            }
          });
        });
      }

      
    }

    pauseVideo() {
      this.image?.classList.remove('close');
      this.switcherVideoButtonState("pause")
      
      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        if (!this.enablePause) {
          this.videoContainer.classList.add('close');
        }

        videos.forEach(video => {
          video.pause();
          if (!this.enablePause) {
            video.currentTime = 0;
          }
        });
      } else {
        this.videoContainer?.remove();
      }
    }

    switcherVideoButtonState (state = "play") {
      if (state == "pause") {
        if (!this.enablePause) {
          this.videoButton?.classList.remove('hide');
        } else {
          this.playVideoButton?.classList.remove('hide');
          this.pauseVideoButton?.classList.add('hide');
        }
        return;
      }
      if (state == "play") {
        if (!this.enablePause) {
          this.videoButton?.classList.add('hide');
        } else {
          this.playVideoButton?.classList.add('hide');
          this.pauseVideoButton?.classList.remove('hide');
        }
        return;
      }
    }

    scheduleHtml5VideoWarmup() {
      // Run once per element instance
      if (this.__ygHtml5WarmupScheduled) return;
      this.__ygHtml5WarmupScheduled = true;

      // Respect "Save-Data" users
      if (navigator?.connection?.saveData) return;

      const run = () => {
        if (!this.isConnected) return;

        try {
          const urls = this.getPreferredHtml5VideoUrls();
          urls.forEach((url) => this.warmupHtml5VideoUrl(url));
        } catch (e) {
          // Never break section rendering due to warmup.
        }
      };

      // Do not preload every video during initial page load. Start the existing
      // low-priority warmup only after the component is within 600px of view.
      if (!('IntersectionObserver' in window)) return;

      this.__ygHtml5WarmupObserver = new IntersectionObserver(
        (entries, observer) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          observer.disconnect();
          this.__ygHtml5WarmupObserver = null;

          // Yield once after intersection so visible images and page UI stay first.
          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(run, { timeout: 1000 });
          } else {
            window.setTimeout(run, 0);
          }
        },
        {
          root: null,
          rootMargin: '600px 0px',
          threshold: 0,
        }
      );

      this.__ygHtml5WarmupObserver.observe(this);
    }

    getPreferredHtml5VideoUrls() {
      const isMobile = window.matchMedia && window.matchMedia('(max-width: 699px)').matches;

      // Prefer template content (when video is deferred) else DOM.
      const root = this.template?.content || this.videoContainer || this;

      // Only HTML5 <video> sources; explicitly skip iframe videos.
      const urls = [];

      // Prefer <source src> which is what Shopify video_tag usually outputs.
      const sources = root.querySelectorAll?.('video.yg-video-iframe source[src]') || [];
      sources.forEach((sourceEl) => {
        const videoEl = sourceEl.closest('video.yg-video-iframe');
        if (!videoEl) return;
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(sourceEl.getAttribute('src'));
      });

      // Fallback: <video src="...">
      const videos = root.querySelectorAll?.('video.yg-video-iframe[src]') || [];
      videos.forEach((videoEl) => {
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(videoEl.getAttribute('src'));
      });

      return [...new Set(urls.filter(Boolean))].filter((u) => !u.startsWith('blob:'));
    }

    warmupHtml5VideoUrl(url) {
      if (!url) return;

      // De-dupe across the whole page
      window.__ygWarmupVideoUrls ||= new Set();
      if (window.__ygWarmupVideoUrls.has(url)) return;
      window.__ygWarmupVideoUrls.add(url);

      // Hint preload (low priority where supported)
      try {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'video';
        link.href = url;
        link.crossOrigin = 'anonymous';
        // Some Chromium builds support this; safe elsewhere.
        link.fetchPriority = 'low';
        document.head.appendChild(link);
      } catch (e) {}

      // Prime HTTP cache with a small Range request (best-effort). Only for same-origin / Shopify CDN to avoid CORS surprises.
      try {
        const u = new URL(url, window.location.href);
        const isSameOrigin = u.origin === window.location.origin;
        const isShopifyCdn = u.hostname.endsWith('cdn.shopify.com');
        if (!isSameOrigin && !isShopifyCdn) return;

        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), 4000);

        fetch(u.toString(), {
          method: 'GET',
          mode: 'cors',
          credentials: 'omit',
          cache: 'force-cache',
          headers: {
            Range: 'bytes=0-1048575',
          },
          signal: controller.signal,
        })
          .catch(() => {})
          .finally(() => window.clearTimeout(timeoutId));
      } catch (e) {}
    }

  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
